import { useState, useEffect } from 'react'
import { Link, NavLink, withRouter } from 'react-router-dom'

import { links } from 'helpers'
import { localisedUrl } from 'helpers/locale'

import CSSModules from 'react-css-modules'
import actions from 'redux/actions'
import cx from 'classnames'

import styles from 'pages/Wallet/Wallet.scss'
import Button from 'components/controls/Button/Button'
import InlineLoader from 'components/loaders/InlineLoader/InlineLoader'
import { BigNumber } from 'bignumber.js'
import config from 'helpers/externalConfig'
import metamask from 'helpers/metamask'
import { FormattedMessage, useIntl } from 'react-intl'
import kaxaa from 'components/ui/CurrencyIcon/images/kaxaa.svg'
import dollar from './images/dollar.svg'
import btc from './images/btcIcon.svg'
import Convert from './images/convert.svg'
import Info from './images/info.svg'
import Copy from '../ui/Copy/Copy'

const BalanceForm = function ({
  activeFiat,
  activeCurrency,
  fiatBalance,
  currencyBalance,
  handleReceive,
  handleWithdraw,
  currency,
  currencyView = false,
  handleInvoice = () => { },
  isFetching = false,
  showButtons = true,
  type,
  singleWallet = false,
  multisigPendingCount = 10,
  history,
  transakType,
}) {

  const { locale } = useIntl()
  const [selectedCurrency, setActiveCurrency] = useState(activeCurrency)
  const isWidgetBuild = config && config.isWidget
  const userCurrencyData = actions.core.getWallets({})

  useEffect(() => {
    if (type === 'wallet' && activeCurrency !== activeFiat.toLowerCase()) {
      setActiveCurrency('kax')
    } else {
      setActiveCurrency(activeCurrency)
    }
  }, [activeCurrency])

  const active = activeFiat ? activeFiat.toLowerCase() : 'usd'

  // @ToDo
  // в Data у валют есть флаги isUserProtected и isSMSProtected
  // нужно по ним проверять, а не по "служебному" названию монеты
  // Use flags in currency data (isUserProtected and isSMSProtected)
  // eslint-disable-next-line default-case
  switch (currency) {
    case 'btc (multisig)':
    case 'btc (pin-protected)':
      currency = 'BTC'
      break
  }

  const handleClickCurrency = (currency) => {
    setActiveCurrency(currency)
    actions.user.pullActiveCurrency(currency)
  }

  const handleGoToMultisig = () => {
    actions.multisigTx.goToLastWallet()
  }

  const buttonsDisabled = !((config.opts.ui.disableInternalWallet && metamask.isConnected()) || !config.opts.ui.disableInternalWallet)

  const sendButtonDisabled = false   // !currencyBalance || buttonsDisabled

  const handleGetKax = () => {
    actions.modals.closeAll();
    history.push(localisedUrl(locale, links.buyKax))
  }

  const handleCustomConvert = () => {
    actions.modals.closeAll();
    history.push(localisedUrl(locale, links.sellKax))
  }

  return (
    <>
      <div
        styleName={
          `${isWidgetBuild && !config.isFullBuild ? 'yourBalance widgetBuild' : 'yourBalance'}`
        }
      >
        <div styleName="yourBalanceTop" className="data-tut-widget-balance">
          <p styleName="yourBalanceDescr">
            {singleWallet
              ? <FormattedMessage id="YourWalletbalance" defaultMessage="Balance" />
              : <FormattedMessage id="Yourtotalbalance" defaultMessage="Ваш общий баланс" />}
          </p>
          <div styleName="yourBalanceValue">
            {isFetching && (
              <div styleName="loaderHolder">
                <InlineLoader />
              </div>
            )}
            {selectedCurrency === active ? (
              // eslint-disable-next-line no-restricted-globals
              <p>
                {(activeFiat === 'USD' || activeFiat === 'CAD') && <img src={dollar} alt="dollar" />}
                {
                  // eslint-disable-next-line no-restricted-globals
                  !isNaN(fiatBalance) ? new BigNumber(fiatBalance).dp(2, BigNumber.ROUND_FLOOR).toString() : ''
                }
              </p>
            ) : (
              <p className="data-tut-all-balance">
                {currency.toUpperCase() === 'BTC' ? <img src={btc} alt="btc" /> : ''}
                {currency.toUpperCase() === 'KAX' ? <img src={kaxaa} styleName="curKaxaa" alt="kax" /> : ''}
                {new BigNumber(currencyBalance).dp(6, BigNumber.ROUND_FLOOR).toString()}
              </p>
            )}
          </div>
          <div styleName="yourBalanceCurrencies">
            <button
              type="button"
              styleName={selectedCurrency === active ? 'active' : undefined}
              onClick={() => handleClickCurrency(active)}
            >
              {active}
            </button>
            <span styleName="separator" />
            <button
              type="button"
              styleName={selectedCurrency === currency ? 'active' : undefined}
              onClick={() => handleClickCurrency(currency)}
            >
              {currencyView || currency}
            </button>
          </div>
        </div>
        {multisigPendingCount > 0 && (
          <div onClick={handleGoToMultisig}>
            <p styleName="multisigWaitCount">
              <FormattedMessage
                id="Balance_YouAreHaveNotSignegTx"
                defaultMessage="{count} transaction needs your confirmation"
                values={{
                  count: multisigPendingCount,
                }}
              />
            </p>
          </div>
        )}
        <div
          className={cx({
            [styles.yourBalanceBottomWrapper]: true,
          })}
        >
          <div styleName="yourBalanceBottom">
            {showButtons ? (
              <div style={{ display: 'grid', gridGap: '10px', width: '100%' }}>
                <div styleName="btns" className="data-tut-withdraw-buttons">
                  <Button blue disabled={buttonsDisabled} id="depositBtn" onClick={() => handleReceive('Deposit')}>
                    <FormattedMessage id="YourtotalbalanceDeposit" defaultMessage="Пополнить" />
                  </Button>
                  <Button blue disabled={sendButtonDisabled} id={!sendButtonDisabled ? 'sendBtn' : ''} onClick={() => handleWithdraw('Send')}>
                    <FormattedMessage id="YourtotalbalanceSend" defaultMessage="Отправить" />
                  </Button>
                </div>
                <div styleName="btns" className="data-tut-withdraw-buttons">
                  <Button blue disabled={buttonsDisabled} onClick={() => handleGetKax()}>
                    Acquire
                  </Button>
                  <Button blue disabled={buttonsDisabled} onClick={() => handleCustomConvert()}>
                    Withdraw
                  </Button>
                </div>
                <NavLink to='/exchange/quick' className='btn-exchange'>
                  Exchange
                </NavLink>
              </div>
            ) : (
              <Button blue disabled={!currencyBalance} styleName="button__invoice" onClick={handleInvoice}>
                <FormattedMessage id="RequestPayment" defaultMessage="Запросить" />
              </Button>
            )}
          </div>
        </div>
      </div>
      {
        window.location.href.includes('exchange/quick')
        && (
          <div className="kaxaa-balance--convert-info">
            <div>
              If you encounter any problems while swapping your crypto, you can
              {' '}
              <a href="mailto:info@kaxaa.com">Contact</a>
              {' '}
              our support team.
            </div>
          </div>)}
      <Copy
        text={userCurrencyData.find((item) => item.currency === 'USDC').address}
      >
        <div
          className='kaxaa-balance--convert-info'
        >
          Your POLYGON Wallet Address is <strong> {userCurrencyData.find((item) => item.currency === 'USDC').address} </strong>
        </div>
      </Copy>
      {transakType === 'on-ramp' && (
        <div className="content" style={{ textAlign: "left" }}>
          <div className='kaxaa-balance--convert-info'>
            <div className='d-flex align-items-start'>
              <div className='icon'>
                <img src={Info} />
              </div>
              <div className='ml-3 mb-1'>
                <h2>ON-RAMP</h2>
                <p>To get KAX tokens, use one of the following options:</p>
                <ul>
                  <li>
                    Go to QuickSwap.
                  </li>
                  <li>
                    Alternatively, use Rango Exchange.
                  </li>
                  <li>
                    Swap your tokens for KAX.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
      {transakType === 'off-ramp' && (
        <>
          <div
            className='kaxaa-balance--convert-info'
          >
            Your current USDC balance is <strong> {userCurrencyData.find((item) => item.currency === 'USDC').balance}</strong>. The minimum balance should be <strong> 11 </strong> USDC.
          </div>
          <div className='kaxaa-balance--convert-info'>
            <div className='d-flex align-items-start'>
              <div className='icon'>
                <img src={Info} />
              </div>
              <div className='ml-3 mb-1'>
                <h2>OFF-RAMP</h2>
                <p>To convert KAX to fiat, follow these steps:</p>
                <ul>
                  <li>
                    Convert KAX to USDC using QuickSwap or Rango.
                  </li>
                  <li>
                    Transfer USDC to a centralized exchange that supports fiat withdrawals.
                  </li>
                  <li>
                    Withdraw your fiat to your bank account.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </>
      )}
      <div
        className='kaxaa-balance--convert-info'
        styleName={
          `${isWidgetBuild && !config.isFullBuild ? 'yourBalance widgetBuild margin-top-10' : 'yourBalance margin-top-10'}`
        }
      >
        <div className='d-flex align-items-start'>
          <div className='icon'>
            <img src={Convert} />
          </div>
          <div className='ml-3 mb-1'>
            <p className='mb-0'>
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              You can convert Kaxaa tokens to USDC (Polygon) on QuickSwap Exchange which operates on the Polygon Network. Polygon (POL) tokens are needed for transactions (deposit, send, widthdraw) on the Polygon chain.
            </p>
            <a className='text-primary' href={'/#/exchange/quick'}> Click Here</a>
          </div>
        </div>

      </div>

    </>
  )
}

export default withRouter(CSSModules(BalanceForm, styles, { allowMultiple: true }))
